import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import { IcoTrash16 } from '@onefootprint/icons';
import type { Locale } from '@onefootprint/request-types';
import { Form, IconButton } from '@onefootprint/ui';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UsLegalStatus } from '../utils/constants';
type CitizenshipFieldProps = {
  name: `citizenships.${number}.value`;
  locale: Locale;
  hasDeleteButton?: boolean;
  onDelete?: () => void;
  disabled?: boolean;
};
export const CitizenshipField = t0 => {
  const $ = _c(30);
  const {
    name,
    locale,
    hasDeleteButton,
    onDelete,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.fields.usLegalStatus.citizenship"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: diToFormData("id.us_legal_status")
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const usLegalStatus = useWatch(t2);
  const isUsCitizen = usLegalStatus === UsLegalStatus.citizen;
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp2);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp3);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isUsCitizen || $[9] !== t) {
    t6 = {
      usCitizen: value => {
        if (value === "US" && !isUsCitizen) {
          return t(_temp4);
        }
        return true;
      }
    };
    $[8] = isUsCitizen;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = {
      required: t5,
      validate: t6
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== disabled || $[15] !== locale || $[16] !== name || $[17] !== t3 || $[18] !== t4 || $[19] !== t7) {
    t8 = <Form.Country name={name} label={t3} placeholder={t4} className="grow" disabled={disabled} locale={locale} rules={t7} />;
    $[14] = disabled;
    $[15] = locale;
    $[16] = name;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const citizenshipSelect = t8;
  if (hasDeleteButton) {
    let t9;
    if ($[21] !== t) {
      t9 = t(_temp5);
      $[21] = t;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== disabled || $[24] !== onDelete || $[25] !== t9) {
      t10 = <IconButton className="mt-8" destructive={true} disabled={disabled} aria-label={t9} onClick={onDelete} icon={IcoTrash16} />;
      $[23] = disabled;
      $[24] = onDelete;
      $[25] = t9;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== citizenshipSelect || $[28] !== t10) {
      t11 = <div className="flex justify-between items-start gap-2">{citizenshipSelect}{t10}</div>;
      $[27] = citizenshipSelect;
      $[28] = t10;
      $[29] = t11;
    } else {
      t11 = $[29];
    }
    return t11;
  }
  return citizenshipSelect;
};
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.placeholder;
}
function _temp3($_1) {
  return $_1.error.empty;
}
function _temp4($_2) {
  return $_2.error.usCitizen;
}
function _temp5($_3) {
  return $_3.deleteAria;
}